import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import history from "history/browser";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

const CustomeLink = ({ children, to, mainState }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const locPathname = location.pathname;
  const arrId = locPathname.split("/");

  const screens = useBreakpoint();
  const isScallingVersion =
    (window?.innerWidth <= 991 && window.innerWidth >= 768) ||
    window?.innerWidth === 581;
  const isMobileVersion = screens.xs || isScallingVersion;

  const highlightHelpItemList = () => {
    document
      .querySelectorAll(".item-list-help")
      .forEach((e) => e.classList.remove("title-active"));
    const itemListArr = document.querySelectorAll(
      ".list-help-topics .item-list-help",
    );

    if (itemListArr.length > 0) {
      itemListArr[0].classList.add("title-active");
    }
  };

  const handleNav = () => {
    // console.log("DALEM CUSTOM LINK")
    if (isMobileVersion) {
      navigate(to, { state: { from: location.pathname } });
    } else {
      history.replace(to);
      mainState.setDefaultKeyListCourse(null);

      mainState.setPopupStream((prevState) => {
        return {
          ...prevState,
          url: to,
        };
      });
      // console.log("SIMPEN")
      if (mainState.popupStream.status === false) {
        // console.log("NAVIGATE")
        // console.log(locPathname)
        if (arrId.indexOf("play") === -1) {
          navigate(to);
        }
      }

      if (children == "Help") {
        highlightHelpItemList();
      }
    }
  };
  return <a onClick={() => handleNav()}>{children}</a>;
};

export default CustomeLink;
